import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { FormSessionCanDeactivate, PatientService, UserService } from '../../shared';
import { environment } from '../../shared/config/app-config';
import * as _ from 'lodash';
import { Options } from '@angular-slider/ngx-slider';
@Component({
  selector: 'app-documentpage1',
  templateUrl: './documentpage1.component.html',
  styleUrls: ['./documentpage1.component.css']
})
export class Documentpage1Component extends FormSessionCanDeactivate {
  public previousUrl: any = [];
  public params: any;
  public user: any = {};
  public surveydate: any = {};
  public survey = [];
  docstatus: any = {};
  // surveyAssociation : any = []
  enablepage = false;
  apiurl: any = environment.api_url
  public currentUser: any;
  intro: any;
  constructor(private router: Router, private routeParams: ActivatedRoute,
    private patientService: PatientService, private userService: UserService) {
    super();
    this.routeParams.params.subscribe(params => {
      this.params = params;
      // //////console.log( this.params)
    });
  }
  ngOnInit() {
    let self = this;
    self.getCurrentUser()
    self.getUserDetails()
    self.getSurveyDetails()
    self.status()
    self.getSurveyDete()
    // this.surveyAssociation = self.userService.getTemporaryData()    
  }
  imageURL: string = environment.cloudeImageURL;
  getCurrentUser() {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
      }
    )

    if (this.currentUser.item.hostModel == "CLOUD")
      this.imageURL = environment.cloudeImageURL;
    else
      this.imageURL = environment.vmImageURL;
  }

  getUserDetails() {
    let self = this;
    self.patientService.getSuveryUserDetais(self.params.patId, self.params.patSwfId)
      .subscribe(data => {
        if (Array.isArray(data) && data.length)
          self.user = data[0]
      })
  }
  result: any;
  innerques: any;
  getSurveyDetails() {
    let self = this;
    self.patientService.getSurveyDetailsbySurevy(self.params.surveyId, self.params.patSwfId, '0')
      .subscribe(data => {
        self.userService.getsurvey(self.params.surveyId, self.params.patSwfId, 1)
          .subscribe(data1 => {
            self.enablepage = true;
            self.result = data1[1].result;
            self.innerques = data1[0].survey.sQuestion
            this.intro = data1[0].survey.introduction;
            data.forEach((element, index) => {
              if (element.active == '1' || (self.result && self.result[index] && self.result[index].resultQuestionId == element.questionId)) {
                self.survey.push(element)
              }
            });

          })
      })
  }
  getSurveyDete() {
    let self = this;
    if (!self.params.oldresultid) {
      self.params.oldresultid = '0'
    }
    self.patientService.getSurveyassigndate(self.params.surveyId, self.params.patSwfId)
      .subscribe(data => {
        // ////console.log(data)
        self.surveydate = data;
      })
  }

  submitForm(emp) {
    let self = this;
    self.patientService.getPatientPassword(emp.email, self.currentUser.item.userAccountId)
      .subscribe(data => {
        if (data.item.status == 'success') {
          self.userService.logAudit('getPassword', 0).subscribe(data => { })
          const credentials = {
            'username': data.item.uname,
            'password': data.item.pwd,
            'captcha': '',
            'mode': '',
            'usermode': localStorage.getItem('userMode') ? atob(localStorage.getItem('userMode')) : 'c',
            'forcelogin': 'true'
          }
          this.loginAsPAtient(credentials)
        }
      })
  }

  loginAsPAtient(credentials) {
    this.userService
      .attemptAuth(credentials)
      .subscribe(
        data => data,
        err => {

        }
      );
  }

  status() {
    switch (this.params.status) {
      case 'Scheduled':
        this.docstatus.status = 'Upcoming'
        this.docstatus.displayStatus = this.userService.translateText('patient_portal.activity_board.upcoming.label')
        this.docstatus.class = 'label-dark'
        break;
      case 'Done':
        this.docstatus.status = 'Completed'
        this.docstatus.displayStatus = this.userService.translateText('hospital_portal.mytodos.completed.label')
        this.docstatus.class = 'label-success'
        break;
      case 'Expired':
        this.docstatus.status = 'Expired'
        this.docstatus.displayStatus = this.userService.translateText('patient_portal.activity_board.expired.label')
        this.docstatus.class = 'label-dark'
        break;
      case 'Not Assigned':
        this.docstatus.status = 'Not Assigned'
        this.docstatus.displayStatus = this.userService.translateText('patient_portal.activity_board.not_assigned.label')
        this.docstatus.class = 'label-dark'
        break;
      default:
        this.docstatus.status = 'Pending'
        this.docstatus.displayStatus = this.userService.translateText('hospital_portal.mytodos.pending.label')
        this.docstatus.class = 'label-warning'
      //////console.log("hetr")
    }
  }
  checkans(result: any[], ansid) {
    let index = _.findIndex(result, (o: any): any => {
      return (o.choicetypeFk == ansid && o.selectAnswerType == null)
    })
    if (index != -1) {
      return true
    } else {
      return false;
    }
  }
  checkold(result: any[], ansid) {
    let index = _.findIndex(result, (o: any): any => {
      return (o.choicetypeFk == ansid && o.selectAnswerType == "OLD")
    })
    let index1 = 0;
    for (var i = 0; i < result.length; i++) {
      if (result[i].choicetypeFk == ansid && (result[i].selectAnswerType == null || result[i].selectAnswerType == undefined)) {
        index1 = -1;
        break;
      }
    }

    if (index != -1 && index1 != -1) {
      return true
    } else {
      return false;
    }
  }
  checknew(result: any[], ansid) {
    let index = _.findIndex(result, (o: any): any => {
      return (o.choicetypeFk == ansid && o.selectAnswerType == null)
    })
    let index1 = -1;
    let oldnew = -1;
    for (var i = 0; i < result.length; i++) {
      if (result[i].choicetypeFk == ansid && result[i].selectAnswerType == "OLD") {
        index1 = i;
        break;
      }
      if (result[i].selectAnswerType == "OLD") {
        oldnew = i
      }
    }

    if (index != -1 && index1 == -1 && oldnew != -1) {
      return true
    } else {
      return false;
    }
  }
  checknewtext(result: any[]) {
    let index = _.findIndex(result, (o: any): any => {
      return (o.selectAnswerType == null)
    })
    let index1 = -1;
    for (var i = 0; i < result.length; i++) {
      if (result[i].selectAnswerType == "OLD") {
        index1 = i;
        break;
      }
    }
    if (index != -1 && index1 != -1) {
      if (result[index].choiceValue != result[index1].choiceValue) {
        return true
      }
    } else {
      return false;
    }
  }

  checksold(result: any[], ansid) {
    let index1
    var answer = result[0].choiceValue.split('##');
    index1 = _.findIndex(answer, (o: any): any => {
      return o == ansid
    })
    let index = -1;
    for (var i = 0; i < result.length; i++) {
      answer = result[i].choiceValue.split('##');
      for (var j = 0; j < answer.length; j++) {
        if (answer[j] == ansid && result[i].selectAnswerType == 'OLD') {
          index = j
        }
      }
    }

    if (index1 == -1 && index != -1) {
      return true
    } else {
      return false;
    }
  }
  checknold(result: any[], ansid) {
    let index1
    var answer = result[0].choiceValue.split('##');
    index1 = _.findIndex(answer, (o: any): any => {
      return o == ansid
    })
    let index = -1;
    let old = -1
    for (var i = 0; i < result.length; i++) {
      answer = result[i].choiceValue.split('##');
      for (var j = 0; j < answer.length; j++) {
        if (answer[j] == ansid && result[i].selectAnswerType == 'OLD') {
          index = j
        }

      }
      if (result[i].selectAnswerType == 'OLD') {
        old = i
      }
    }

    if (index1 != -1 && index == -1 && old != -1) {
      return true
    } else {
      return false;
    }


  }
  checksans(result: any[], ansid) {
    let index
    var answer = result[0].choiceValue.split('##');
    index = _.findIndex(answer, (o: any): any => {
      return o == ansid
    })
    if (index != -1) {
      return true
    } else {
      return false;
    }
  }
  checknans(result: any[], ansid) {
    let index
    var answer = result[0].choiceValue.split('##');

    index = _.findIndex(answer, (o: any): any => {
      return o == ansid
    })

    if (index == -1) {
      if (result[0].choiceValue == '') {
        return false
      }
      else
        return true;
    } else {
      return false;
    }
  }
  surveydownloadurl: any = environment.surveydownloadUrl;
  onPrint() {
    let printContents;
    let data: any = {
      preview: true,
      hspPatSurveyId: this.params.surveyId,
      patientSwfId: this.params.patSwfId,
      lang: this.userService.selectedLang()
    }
    data = this.userService.encrypt(JSON.stringify(data))
    data = btoa(data)
    printContents = this.surveydownloadurl + data
    // printContents = document.getElementById('print-section').innerHTML;
    window.open(printContents, '_blank', 'top=0,left=0,height=100%,width=auto');
  }
  getnullvalue(value) {
    if (value) {
      if (value.toLowerCase() == 'null') {
        return ''
      } else {
        return value
      }
    } else {
      return ''
    }
  }
  textques: any;
  getinnerques(result, ques, index) {
    let self = this
    if (index) {
      try{
        let index1 = _.findIndex(self.innerques[index].sAnswer, (o: any): any => {
          return o.ansChoicetypeId == ques.resultDetailList[0].choicetypeFk
        })
        if (index1 != -1) {
          let index2 = _.findIndex(self.innerques[index].sAnswer[index1].innerChoice, (o: any): any => {
            return o.innerChoicePk == result.innerChoicePk
          })
          if (index2 != -1) {
            if (result.innerQuestionType == 'textbox' && self.innerques[index].sAnswer[index1].innerChoice[index2].innerAnsChNameArray.length == 1)
              return self.innerques[index].sAnswer[index1].innerChoice[index2].innerAnsChNameArray[0].innerAnsChName
            else if (result.innerQuestionType == 'textbox' && self.innerques[index].sAnswer[index1].innerChoice[index2].innerAnsChNameArray.length > 1) {
              self.textques = self.innerques[index].sAnswer[index1].innerChoice[index2].innerAnsChNameArray
              return 'multi'
            }
            else
              return self.innerques[index].sAnswer[index1].innerChoice[index2].innerQuestionName
          }
        }
      } catch(error) { }
      return ''
    }
  }
  getinnerans(result, ques, index) {
    let self = this
    if (index) {
      let index1 = _.findIndex(self.innerques[index].sAnswer, (o: any): any => {
        return o.ansChoicetypeId == ques.resultDetailList[0].choicetypeFk
      })
      if (index1 != -1) {
        let index2 = _.findIndex(self.innerques[index].sAnswer[index1].innerChoice, (o: any): any => {
          return o.innerChoicePk == result.innerChoicePk
        })
        if (index2 != -1) {
          let innerques = self.innerques[index].sAnswer[index1].innerChoice[index2].innerAnsChNameArray[0].innerAnsChName
          if (result.innerQuestionType == 'textbox')
            // return result.innerAnswerValue[innerques]
            return result.innerAnswerValue
          else
            return result.innerAnswerValue
        }
      }
    }
    return ''
  }
  getinnnerchoice(result, ques, index) {
    let self = this
    let index1 = _.findIndex(self.innerques[index].sAnswer, (o: any): any => {
      return o.ansChoicetypeId == ques.resultDetailList[0].choicetypeFk
    })
    if (index1 != -1) {
      let index2 = _.findIndex(self.innerques[index].sAnswer[index1].innerChoice, (o: any): any => {
        return o.innerChoicePk == result.innerChoicePk
      })
      if (index2 != -1)
        return self.innerques[index].sAnswer[index1].innerChoice[index2].innerAnsChNameArray
    }
  }

  getName(name) {
    if (name) {
      let title = name.toLowerCase()
      if (title.search('pain') != -1) {
        return true
      } else
        return false
    } else {
      return false
    }
  }

  sliderOption(anstype) {
    let options: Options = {
      floor: 0,
      ceil: anstype.max,
      step: 1,
      minRange: anstype.min,
      maxRange: anstype.max,
      showTicks: true,
      getLegend: (value: number): any => {
        return value;
      }
    };
    return options
  }

}
